module.exports = __webpack_public_path__ + "static/img/pc-2.8126a5ca.png";